import React from 'react';
import { Route, HashRouter } from 'react-router-dom';

import Home from './pages/Home';
import Produto from './pages/Produto';
import Carrinho from './pages/Carrinho';
import Checkout from './pages/Checkout';
import PedidoPix from './pages/PedidoPix';
import PedidoWhatsapp from './pages/PedidoWhatsapp';
import Identificacao from './pages/Identificacao';

const Routes = () => {
    return (
        <HashRouter>
            <Route component={Home} path="/" exact />
            <Route component={Identificacao} path="/identificacao" exact />
            <Route component={Produto} path="/produto/:id" exact />
            <Route component={Carrinho} path="/carrinho" exact />
            <Route component={Checkout} path="/checkout" exact />
            <Route component={PedidoPix} path="/pedido-pix" exact />
            <Route component={PedidoWhatsapp} path="/pedido-whatsapp" exact />
        </HashRouter>
    );
}

export default Routes;
